import React from 'react';
import LegalPageLayout, { H2, P } from '../../components/LegalPageLayout';
import { WhatsappLogo, EnvelopeSimple, Phone } from '@phosphor-icons/react';

export default function ContactUs() {
  return (
    <LegalPageLayout title="Contact Us" lastUpdated="May 31, 2026" testId="contact-page">
      <P>
        We're here to help with any questions about consultations, payments, doctor applications, or your
        existing case.
      </P>

      <div className="grid sm:grid-cols-2 gap-4 my-6">
        <a
          href="https://wa.me/918840804798"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-start gap-3 p-5 rounded-lg border-2 border-primary/20 hover:border-primary hover:bg-primary/5 transition-all"
          data-testid="contact-whatsapp"
        >
          <WhatsappLogo size={32} weight="duotone" style={{ color: '#25D366' }} />
          <div>
            <p className="font-semibold text-primary">WhatsApp (Preferred)</p>
            <p className="text-sm text-secondary">+91 88408 04798</p>
            <p className="text-xs text-secondary mt-1">Fastest response · Mon–Sat 9 AM – 9 PM IST</p>
          </div>
        </a>

        <a
          href="mailto:support@seconddoctoropinion.com"
          className="flex items-start gap-3 p-5 rounded-lg border-2 border-primary/20 hover:border-primary hover:bg-primary/5 transition-all"
          data-testid="contact-email"
        >
          <EnvelopeSimple size={32} weight="duotone" className="text-primary" />
          <div>
            <p className="font-semibold text-primary">Email Support</p>
            <p className="text-sm text-secondary">support@seconddoctoropinion.com</p>
            <p className="text-xs text-secondary mt-1">Response within 24 hours</p>
          </div>
        </a>

        <a
          href="tel:+918840804798"
          className="flex items-start gap-3 p-5 rounded-lg border-2 border-primary/20 hover:border-primary hover:bg-primary/5 transition-all"
          data-testid="contact-phone"
        >
          <Phone size={32} weight="duotone" className="text-primary" />
          <div>
            <p className="font-semibold text-primary">Phone</p>
            <p className="text-sm text-secondary">+91 88408 04798</p>
            <p className="text-xs text-secondary mt-1">Mon–Sat 9 AM – 9 PM IST</p>
          </div>
        </a>

        <div className="flex items-start gap-3 p-5 rounded-lg border-2 border-primary/20">
          <div className="w-8 h-8 flex items-center justify-center text-primary font-bold">📍</div>
          <div>
            <p className="font-semibold text-primary">Address</p>
            <p className="text-sm text-secondary">Lucknow, Uttar Pradesh, India</p>
            <p className="text-xs text-secondary mt-1">Operating across India</p>
          </div>
        </div>
      </div>

      <H2>Specialized Queries</H2>
      <P>
        <strong>Privacy / Data Requests:</strong> privacy@seconddoctoropinion.com<br />
        <strong>Grievance Officer:</strong> grievance@seconddoctoropinion.com<br />
        <strong>Doctor Panel Inquiries:</strong> doctors@seconddoctoropinion.com<br />
        <strong>Press / Partnerships:</strong> press@seconddoctoropinion.com
      </P>

      <H2>Emergencies</H2>
      <P>
        For medical emergencies, please call <strong>112</strong> (India emergency services) or visit the
        nearest hospital immediately. SecondDoctorOpinion.com does not provide emergency care.
      </P>
    </LegalPageLayout>
  );
}
